import { Attributes, LookupBase } from '@singularsystems/neo-core';

export default class SurveyParticipantDocumentLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public readonly surveyParticipantDocumentId: number = 0;

    public readonly documentName: string = "";

    public uploadedFileName: string = "";

    @Attributes.Date()
    public respondedOn: Date | null = null;

    // Client only properties / methods
}